import { useState, useEffect } from 'react';
import { NProgress } from '@tanem/react-nprogress';

const ProgressBar = ({ isAnimating }: { isAnimating: boolean | undefined }) => {
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (isAnimating) {
      setReset(false); // 动画开始时不重置
    } else if (!isAnimating) {
      setReset(true); // 动画结束时重置
    }
  }, [isAnimating]);

  return (
    <NProgress isAnimating={isAnimating}>
      {({ isFinished, progress, animationDuration }) => {
        // 如果进度条完成并且需要重置，将进度条复原到初始状态
        const finalProgress = isFinished && reset ? 0 : progress;

        return (
          <div
            style={{
              pointerEvents: 'none',
              opacity: isFinished ? 0 : 1,
              transition: `opacity ${animationDuration}ms linear`,
            }}
          >
            <div
              style={{
                background: '#D70B17', // 进度条颜色
                height: 4, // 进度条高度
                left: 0,
                marginLeft: `${(-1 + finalProgress) * 100}%`,
                position: 'fixed',
                top: 0,
                transition: `margin-left ${animationDuration}ms linear`,
                width: '100%',
                zIndex: 1031,
              }}
            />
          </div>
        );
      }}
    </NProgress>
  );
};

export default ProgressBar;
